import React from 'react';

export default class PopoverWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.hidePopovers = this.hidePopovers.bind(this);
  }

  hidePopovers(e) {
    const openPops = document.querySelectorAll('.popover--active');
    [].forEach.call(openPops, (popOver) => {
      popOver.classList.remove('popover--active');
      popOver.classList.remove('anim__open');
      Utils.fireEvent(popOver, 'popover:closed', { popOver });
    });
  }

  render() {
    return (
      <div
        className="popoverWrap"
        onClick={this.hidePopovers.bind(this)}
        onTouchEnd={this.hidePopovers.bind(this)}
        {...this.props}
      >
        {this.props.children}
      </div>
    );
  }
}
